import type { LicenseExtraField } from './types';

const EXTRA_LABELS: Record<string, string> = {
  idesp: 'IDESP / IXESP (nº soporte DNI)',
  license_code: 'Código de licencia (P + 8 dígitos)',
  previous_license: 'Nº de licencia anterior',
  island: 'Isla',
  tarjeta_anverso: 'Foto del anverso de la tarjeta',
  tarjeta_reverso: 'Foto del reverso de la tarjeta',
  psicofisico: 'Informe psicofísico',
  id_doc_front: 'Anverso del documento',
  id_doc_back: 'Reverso del documento',
  acc_doc: 'Documento acreditativo',
  auth_doc: 'Autorización firmada',
};

const DOC_FIELD_IDS = new Set([
  'tarjeta_anverso',
  'tarjeta_reverso',
  'psicofisico',
  'id_doc_front',
  'id_doc_back',
  'acc_doc',
  'auth_doc',
]);

export function isEvidenceRef(value: string): boolean {
  const v = String(value || '').trim();
  return v.startsWith('license-evidence/') && !v.includes('://');
}

export function extraFieldLabel(id: string, extraFields?: LicenseExtraField[]): string {
  const fromRecipe = extraFields?.find((f) => f.id === id)?.label?.trim();
  if (fromRecipe) return fromRecipe;
  return EXTRA_LABELS[id] || id;
}

export function extraFieldDisplayValue(
  id: string,
  value: string,
  extraFields?: LicenseExtraField[]
): string {
  const opt = extraFields
    ?.find((f) => f.id === id)
    ?.options?.find((o) => o.value === value);
  return opt?.label || value;
}

export function extrasAsRows(
  extras: Record<string, string> | undefined,
  extraFields?: LicenseExtraField[]
): Array<{ id: string; label: string; value: string; isEvidence: boolean }> {
  if (!extras) return [];
  return Object.entries(extras)
    .filter(
      ([id, value]) =>
        id !== 'docs_purged' &&
        id !== 'pending_applicant_from_id' &&
        id !== 'product_label' &&
        id !== 'duration_label' &&
        String(value || '').trim()
    )
    .map(([id, value]) => {
      const ref = isEvidenceRef(value);
      const knownDoc = DOC_FIELD_IDS.has(id);
      return {
        id,
        label: extraFieldLabel(id, extraFields),
        value: ref ? '' : knownDoc ? 'Sin archivo' : extraFieldDisplayValue(id, value, extraFields),
        isEvidence: ref,
      };
    });
}

export function fullApplicantName(a: {
  firstName?: string;
  lastName?: string;
  secondLastName?: string;
}): string {
  return [a.firstName, a.lastName, a.secondLastName].filter(Boolean).join(' ').trim();
}
